<template>
    <div>
        <model-filter @filtered = " (val) => extraFilters = {...extraFilters, ...val }"></model-filter>
        <elements-layout
              :table-columns='tableColumns'
              :fetch-data-url='fetchDataUrl'
              :delete-data-url='deleteDataUrl'

              :tableRepresentation="true"

              :store-module-name="STORE_MODULE_NAME"
              :store-module-config="STORE_MODULE_CONFIG"

              :addDataSidebarAvailable="$can('create', 'userpermission')"

              :useDefaultActions="[ $can('delete', 'userpermission') ? 'delete': null]"
              idKey="id"
              :searchFieldActive="false"

              :extraFilters="extraFilters"
      >

        <template #addDataForm>
          <model-add-update></model-add-update>
        </template>

        <template #tableCellCustomRepresentations="cell">

            <template v-if="cell.field.key === 'user'">
                <template v-if="get(cell.value, 'id')">
                    <user-cell :user="cell.value"></user-cell>
                </template>
                <template v-else>
                    {{cell.value}}
                </template>
            </template>
            <template v-if="cell.field.key === 'permission'">
                <template v-if="get(cell.value, 'id')">
                    <permission-cell :permission="cell.value"></permission-cell>
                </template>
                <template v-else>
                    {{cell.value}}
                </template>
            </template>
        </template>

      </elements-layout>
    </div>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from './modelStoreModule'
  import useModel from './useModel'

  import ModelAddUpdate from './modelAddUpdate/ModelAddUpdate'
  import UserCell from "../../user/components/UserCell";

  import get from 'lodash.get'
  import PermissionCell from "../../permission/components/PermissionCell";
  import ModelFilter from "./components/ModelFilter";

  export default {
    components: {
        ModelFilter,
        ElementsLayout,
        PermissionCell,
        UserCell,
        ModelAddUpdate,
    },
    setup() {

      const {
          fetchDataUrl,
          deleteDataUrl,
          tableColumns,
          extraFilters
      } = useModel();

      return {
          fetchDataUrl,
          deleteDataUrl,
          tableColumns,
          extraFilters,

          STORE_MODULE_NAME,
          STORE_MODULE_CONFIG,

          get
      }
    },
  }
</script>
